import { ProjectSpecifications } from "./project-specifications.type";

type SpecsNoContractee = Omit<ProjectSpecifications, "contractee">;

export type ProjectSpecificationsForm =
  { [K in keyof SpecsNoContractee]-?: Exclude<SpecsNoContractee[K], undefined> | null }
  & Pick<ProjectSpecifications, "contractee">;
/* eslint-disable @tseslint/no-non-null-assertion */
export function parseToProjectSpecifications (
  value: ProjectSpecificationsForm
): ProjectSpecifications {
  return {
    category: value.category!,
    clientType: value.clientType ?? undefined,
    clientTypeCategory: value.clientTypeCategory ?? undefined,
    clientTypeModel: value.clientTypeModel ?? undefined,
    allocationType: value.allocationType ?? undefined,
    confidential: value.confidential ?? undefined,
    contractee: value.contractee,
    currency: value.currency!,
    grossArea: value.grossArea ?? undefined,
    grossVolume: value.grossVolume ?? undefined,
    heritageProtected: value.heritageProtected ?? undefined,
    mainUsage: value.mainUsage ?? undefined,
    orderVolume: value.orderVolume && value.orderVolume !== "" ? value.orderVolume : undefined,
    projectType: value.projectType!,
    scope: value.scope ?? undefined,
    sideUsage: value.sideUsage ?? undefined,
    totalOutput: value.totalOutput && value.totalOutput !== "" ? value.totalOutput : undefined
  } satisfies ProjectSpecifications;
}
/* eslint-enable @tseslint/no-non-null-assertion */
export function parseToProjectSpecificationsForm (
  value: ProjectSpecifications
): ProjectSpecificationsForm {
  return {
    category: value.category,
    clientType: value.clientType ?? null,
    clientTypeCategory: value.clientTypeCategory ?? null,
    clientTypeModel: value.clientTypeModel ?? null,
    allocationType: value.allocationType ?? null,
    confidential: value.confidential ?? null,
    currency: value.currency,
    contractee: value.contractee,
    grossArea: value.grossArea ?? null,
    grossVolume: value.grossVolume ?? null,
    heritageProtected: value.heritageProtected ?? null,
    mainUsage: value.mainUsage ?? null,
    // TODO Ngx-mask seems to have a problem with null
    orderVolume: value.orderVolume ?? "",
    projectType: value.projectType,
    scope: value.scope ?? null,
    sideUsage: value.sideUsage ?? null,
    totalOutput: value.totalOutput ?? ""
  } satisfies ProjectSpecificationsForm;
}
